import Popup from '@/components/mm100Preview/Popup';
import Image from '@/components/UI/Image';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import { f } from '@/utils';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { useGlobal } from '@/utils/useGlobal';
import { TimelineMax, TweenMax } from 'gsap';
import debounce from 'lodash/debounce';
import lottie from 'lottie-web';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import useCodeSegment from './useCodeSegment';
import useService from './useService';
export default function Preview() {
    const { useLang, useState, useEffect, isMobile, gtm, useRouter } = useGlobal();
    const { locale, isReady } = useRouter();
    const { t } = useLang('ecoflowpowerkits');
    const [swiper, setSwiper] = useState(null);
    const [lottieDedtroyFlag, setLottieDedtroyFlag] = useState(false);
    const [popupVisible, setPopupVisible] = useState(false);
    let layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    let controller: any;
    let lottieHeaderA: any;

    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    const segment = useCodeSegment(
        {
            send_btn: t('preview.get_preview'),
            placeholder: t('preview.email_holder'),
        },
        locale,
    );

    useEffect(() => {
        controller = new ScrollMagic.Controller();
        if (!lottieHeaderA) {
            lottieHeaderA = lottie.loadAnimation({
                container: document.querySelector('.lottieHeaderA-1'),
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: f('/img/mm100/kv-light.json'),
            });
            lottieHeaderA.play();
        }
    }, []);

    const infoLists = [
        { key: 1, i18n: 'info_1' },
        { key: 2, i18n: 'info_2' },
        { key: 3, i18n: 'info_3' },
        { key: 4, i18n: 'info_4' },
        { key: 5, i18n: 'info_5' },
    ];

    const moreLists = [
        {
            key: 1,
            title: 'more_1_title',
            desc: 'more_1_desc',
            note: '*パワーハブのオルタネーターポートをソーラーパネルの接続に使用し、合計3枚のソーラーパネルでソーラー充電を行った場合の最大入力値です。',
            img: '/img/mm100/preview/4-charge.jpg',
        },
        {
            key: 2,
            title: 'more_2_title',
            desc: 'more_2_desc',
            img: '/img/mm100/preview/5-safety.jpg',
        },
        {
            key: 3,
            title: 'more_3_title',
            desc: 'more_3_desc',
            img: `/img/mm100/preview/7-monitor-${locale === 'jp' ? 'jp' : 'en'}.jpg`,
        },
        {
            key: 4,
            title: 'more_4_title',
            desc: 'more_4_desc',
            img: `/img/mm100/preview/6-smart-${locale === 'jp' ? 'jp' : 'en'}.jpg`,
        },
    ];

    const handleBackToEmail = () => {
        gtm.push({ event: 'uaEvent', event_name: 'activity_preview', button_name: 'get_preview' });
        layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        if (layoutH < 1100) {
            window.scrollTo(0, 1230 - layoutH);
        } else {
            window.scrollTo(0, 320);
        }
    };

    const handleMouseEnter = () => {
        swiper?.autoplay?.stop();
    };

    const handleMouseLeave = () => {
        swiper?.autoplay?.start();
    };

    const handleReachEnd = () => {
        swiper.params.autoplay.reverseDirection = true;
    };

    const handleReachBeginning = () => {
        swiper.params.autoplay.reverseDirection = false;
    };

    useEffect(() => {
        let errObserver: any = null;
        let otherErrObserver: any = null;
        let successObserver: any = null;

        // prevent reload again
        if (isReady) {
            loadScript('//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js').then(($: any) => {
                useService();

                // 原插件是基于jquery写的业务，为了适配本补充一些jquery代码来适配功能页面业务，
                const inputNode: any = document.querySelector('#mce-EMAIL');
                const emailWrapper: any = document.querySelector('.email-wrapper');
                const CLASSNAME = 'input-focus';
                const $responseMsg = $('.email-response-msg');
                const config = { childList: true, subtree: true };
                let isClicked = false;

                const errorCallback = function (mutationsList: any) {
                    const mutation = mutationsList.filter((item: any) => item.type === 'childList');

                    if (mutation.length > 0 && isClicked) {
                        // 原事件是失焦校验，现改为需要点击提交才校验
                        $responseMsg.removeClass('success').addClass('error');
                        $responseMsg.text(t('preview.email_validation_error'));

                        if (isMobile) {
                            $('.email-wrapper').addClass('validate-error');
                        }
                        $('.email-response-msg.error').show();
                        isClicked = false;

                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_submit',
                            button_name: 'get_preview',
                            status: 'fail',
                        });
                    }
                };

                const otherErrorCallback = function (mutationsList: any) {
                    const mutation = mutationsList.filter((item: any) => item.type === 'childList');

                    if (mutation.length > 0 && isClicked) {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_submit',
                            button_name: 'get_preview',
                            status: 'fail',
                        });
                        $responseMsg.removeClass('success').addClass('error');
                        $responseMsg.text(t('preview.email_unknown_error'));
                        if (isMobile) {
                            $('.email-wrapper').addClass('validate-error');
                        }
                        $('.email-response-msg.error').show();
                        isClicked = false;
                    }
                };

                const successCallback = function (mutationsList: any) {
                    const mutation = mutationsList.filter((item: any) => item.type === 'childList');
                    const btn = document.querySelector('#mc-embedded-subscribe');

                    if (mutation.length > 0) {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_submit',
                            button_name: 'get_preview',
                            status: 'success',
                        });
                        $responseMsg.removeClass('error').addClass('success');
                        $responseMsg.text(t('preview.email_validation_success'));
                        $('.email-response-msg.success').show().delay(5000).fadeOut();

                        if (isMobile) {
                            $('.email-wrapper').removeClass('validate-error');
                            btn?.setAttribute('disabled', 'disabled');
                        }
                        if (locale === 'us') {
                            setPopupVisible(true);
                        }
                    }
                };

                errObserver = new MutationObserver(errorCallback);
                otherErrObserver = new MutationObserver(otherErrorCallback);
                successObserver = new MutationObserver(successCallback);

                errObserver.observe($('.mc-field-group')[0], config);
                otherErrObserver.observe($('#mce-error-response')[0], config);
                successObserver.observe($('#mce-success-response')[0], config);

                $(inputNode).on(
                    'input',
                    debounce(() => {
                        if (!$(inputNode).val()) {
                            $('.email-wrapper').removeClass('validate-error');
                            $('.email-response-msg.error').hide();
                        }
                    }, 200),
                );

                inputNode.onfocus = function () {
                    if (!emailWrapper.classList.contains(CLASSNAME)) {
                        emailWrapper.classList.add(CLASSNAME);
                    }
                };

                inputNode.onblur = function () {
                    emailWrapper.classList.remove(CLASSNAME);
                };

                $('#mc-embedded-subscribe')
                    .off('click')
                    .on('click', () => {
                        isClicked = true;
                        window?.fbq && window?.fbq('track', 'Lead');
                    });

                if (isMobile) {
                    $('#mce-EMAIL').on('input', () => {
                        const val = $('#mce-EMAIL').val();
                        const btn = document.querySelector('#mc-embedded-subscribe');

                        if (val.length) {
                            btn?.removeAttribute('disabled');
                        } else {
                            btn?.setAttribute('disabled', 'disabled');
                        }
                    });
                }
            });
        }

        return () => {
            errObserver?.disconnect();
            otherErrObserver?.disconnect();
            successObserver?.disconnect();
        };
    }, []);

    // 第1屏-文字动画
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.mm100-preview .mm100-section-a',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 100, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.to('.mm100-preview .mm100-section-a-move', 0.5, {
            opacity: 0,
            y: -200,
            ease: 'none',
        });
        sceneA1.setTween(tweenA1);

        controller.addScene(sceneA1);
    }, []);

    // 第2屏-图片动画
    useEffect(() => {
        const totalTime = 1.5;
        const sceneE1 = new ScrollMagic.Scene({
            triggerElement: '.mm100-preview .mm100-section-b',
            offset: 63, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 250, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        //让首屏lottle动画消失,解决性能问题
        let flag = true;
        sceneE1.on('progress', (self: any) => {
            if (self.progress > 0.3 && flag) {
                lottieHeaderA.destroy();
                setLottieDedtroyFlag(true);
                flag = false;
            }
        });
        const timelineE1 = new TimelineMax();
        // 整体缩放位移
        const tweenE1 = TweenMax.fromTo(
            '.mm100-preview .mm100-preview-box',
            totalTime,
            {
                scale: 1,
                y: 0,
                ease: 'none',
            },
            {
                scale: 0.575,
                y: 50,
                ease: 'none',
            },
        );

        // 主图（所有图）渐显
        const tweenE2 = TweenMax.to('.mm100-preview .mm100-preview-img-2', 0.5, {
            opacity: 1,
            ease: 'none',
        });
        // 背景图渐显
        const tweenE3 = TweenMax.to('.mm100-preview .mm100-preview-bg', 1, {
            opacity: 1,
            ease: 'none',
        });
        // 光线图渐隐
        const tweenE3_1 = TweenMax.to('.mm100-preview .mm100-preview-img-4', 1, {
            opacity: 0,
            ease: 'none',
        });
        // 图层上文字
        const tweenE4 = TweenMax.fromTo(
            '.mm100-preview .mm100-preview-textOnImg-move',
            1,
            {
                opacity: 0,
                y: 150,
                ease: 'none',
            },
            {
                opacity: 1,
                y: 0,
                ease: 'none',
            },
        );
        //闪亮图消失
        const tweenE5 = TweenMax.to('.mm100-preview .lottieHeaderA-1', 1.5, {
            opacity: 0,
            ease: 'none',
        });

        timelineE1.add(tweenE1, 0).add(tweenE5, 0).add(tweenE2, 0).add(tweenE3, 0.5).add(tweenE3_1, 0.5).add(tweenE4, 0.5);
        sceneE1.setTween(timelineE1);

        controller.addScene(sceneE1);
    }, []);

    // 第2屏-文字渐变-1
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.mm100-preview .mm100-preview-reasonTextTop',
            offset: 50, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 100, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timelineA1 = new TimelineMax();
        const tweenA1 = TweenMax.fromTo(
            '.mm100-preview .text-left',
            0.5,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );
        const tweenA2 = TweenMax.fromTo(
            '.mm100-preview .text-right',
            0.5,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );

        timelineA1.add(tweenA1, 0).add(tweenA2, 0);
        sceneA1.setTween(timelineA1);

        controller.addScene(sceneA1);
    }, []);

    // 第2屏-文字渐变-2
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.mm100-preview .mm100-preview-saveSpace',
            offset: 150, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 100, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timelineA1 = new TimelineMax();
        const tweenA1 = TweenMax.fromTo(
            '.mm100-preview .save-space',
            0.5,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );
        const tweenA2 = TweenMax.fromTo(
            '.mm100-preview .save-space-desc',
            0.5,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );

        timelineA1.add(tweenA1, 0).add(tweenA2);
        sceneA1.setTween(timelineA1);

        controller.addScene(sceneA1);
    }, []);

    // 第2屏-文字渐变-3
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.mm100-preview .whatsMore-title',
            offset: 50, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 100, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.fromTo(
            '.mm100-preview .whatsMore-title',
            0.5,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );

        sceneA1.setTween(tweenA1);

        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`mm100-preview ${css.mm100Preview}`}>
            <div className="mm100-section-a">
                <div className="mm100-section-a-move">
                    <h4 className="mm100-preview-coming-date">{t('preview.coming_date')}</h4>
                    <h2 className="mm100-preview-title">{t('title')}</h2>
                    <h4 className="mm100-preview-simple">{t('preview.simple')}</h4>
                </div>
            </div>

            <div className="mm100-section-b">
                <div className="mm100-preview-out-box">
                    <div className="mm100-preview-box">
                        <div className="mm100-preview-img-box">
                            <div className="mm100-preview-img mm100-preview-img-2">
                                <Image
                                    src="/img/mm100/preview/MM100kv_2.png"
                                    layout="fill"
                                    className="fullImgs"
                                    alt={t('preview.title')}
                                    aria-label={t('preview.title')}
                                />
                            </div>
                            <div className="mm100-preview-img mm100-preview-img-3 lottieHeaderA-1"></div>
                            <div className={`mm100-preview-img mm100-preview-img-4 ${lottieDedtroyFlag ? 'img-show' : ''}`}>
                                <Image
                                    src="/img/mm100/images/img_1.png"
                                    layout="fill"
                                    className="fullImgs"
                                    alt={t('preview.title')}
                                    aria-label={t('preview.title')}
                                    noUseSrcset={true}
                                />
                            </div>
                        </div>
                        <div className="mm100-preview-bg">
                            <Image
                                src="/img/mm100/preview/MM100_kv_bg.png"
                                layout="fill"
                                className="fullImgs"
                                alt={t('preview.title')}
                                aria-label={t('preview.title')}
                            />
                        </div>
                    </div>
                    <div className="mm100-preview-textOnImg">
                        <div className="mm100-preview-textOnImg-move" id="mm100-preview-textOnImg">
                            <p className="mm100-preview-desc">{t('preview.desc')}</p>
                            <div className="mm100-preview-controls">
                                <p className="mm100-preview-email-desc">{t('preview.desc2')}</p>
                                <div className="image-bg" dangerouslySetInnerHTML={{ __html: segment }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {locale === 'jp' && (
                <div className="mm100-preview-special-activity">
                    <div className="img-wrapper">
                        <Image
                            src="/img/mm100/preview/border-bg.png"
                            layout="fill"
                            className="fullImgs"
                            alt={t('preview.title')}
                            aria-label={t('preview.title')}
                        />
                    </div>
                    <h1 className="special-activity-desc">{t('preview.special_activity_desc')}</h1>
                    <a className="special-activity-btn" href={t('preview.special_activity_url')}>
                        {t('preview.special_activity_btn')}
                        <span className="icon-left">
                            <EFArrowLeft />
                        </span>
                    </a>
                </div>
            )}

            {locale === 'us' && (
                <div className="mm100-preview-what-power-kits">
                    <h1 className="what-power-kits-title">{t('preview.what_power_kits_title')}</h1>
                    <p className="what-power-kits-desc">{t('preview.what_power_kits_desc')}</p>
                    <div className="img-wrapper">
                        <div className="img-off-grid">
                            <Image
                                src="/img/mm100/preview/off-grid.jpg"
                                layout="fill"
                                className="fullImgs"
                                alt={t('preview.what_power_kits_title')}
                                aria-label={t('preview.what_power_kits_title')}
                            />
                            <div className="img-name">Off-grid Builds</div>
                        </div>
                        <div className="img-rv">
                            <Image
                                src="/img/mm100/preview/rv.jpg"
                                layout="fill"
                                className="fullImgs"
                                alt={t('preview.what_power_kits_title')}
                                aria-label={t('preview.what_power_kits_title')}
                            />
                            <div className="img-name">Vans/RVs/Trailers</div>
                        </div>
                    </div>
                </div>
            )}

            {locale === 'jp' && (
                <div className="mm100-preview-what-power-kits">
                    <div className="img-wrapper">
                        <div className="img-off-grid">
                            <Image
                                src="/img/mm100/preview/off-grid.jpg"
                                layout="fill"
                                className="fullImgs"
                                alt={t('preview.what_power_kits_title')}
                                aria-label={t('preview.what_power_kits_title')}
                            />
                            <div className="img-name">オフグリッドハウス</div>
                        </div>
                        <div className="img-rv">
                            <Image
                                src="/img/mm100/preview/rv.jpg"
                                layout="fill"
                                className="fullImgs"
                                alt={t('preview.what_power_kits_title')}
                                aria-label={t('preview.what_power_kits_title')}
                            />
                            <div className="img-name">キャンピングカー/バン</div>
                        </div>
                    </div>
                </div>
            )}

            <div className="container">
                <div className="mm100-preview-reason">
                    <div className="mm100-preview-reasonTextTop">
                        <h1 className="text-left">{t('preview.why')}</h1>
                        <div className="text-right">
                            <h3 className="set-up">{t('preview.set_up')}</h3>
                            <p className="set-up-desc">{t('preview.set_up_desc')}</p>
                        </div>
                    </div>
                    <div className="mm100-preview-reasonImg">
                        <Image
                            src="/img/mm100/preview/2-simple.jpg"
                            width={1120}
                            height={640}
                            className="fullImgs"
                            alt={t('preview.set_up')}
                            aria-label={t('preview.set_up')}
                        />
                    </div>
                </div>
            </div>
            <div className="mm100-preview-saveSpace">
                <Image
                    src="/img/mm100/preview/3-save.jpg"
                    layout="fill"
                    className="fullImgs"
                    alt={t('preview.save_space')}
                    aria-label={t('preview.save_space')}
                />
                <div className="mm100-preview-saveSpaceText container">
                    <h3 className="save-space">{t('preview.save_space')}</h3>
                    <p className="save-space-desc">{t('preview.save_space_desc')}</p>
                </div>
            </div>
            <div className="mm100-preview-whatsMore">
                <h1 className="whatsMore-title">{t('preview.whats_more')}</h1>
                <Swiper
                    modules={[Autoplay]}
                    pagination={{
                        clickable: true,
                    }}
                    className="m100-preview-swiper"
                    slidesPerView={'auto'}
                    initialSlide={0}
                    preloadImages={false}
                    lazy={true}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    spaceBetween={26}
                    centeredSlides={true}
                    grabCursor={true}
                    onSwiper={(swiper: any) => setSwiper(swiper)}
                    onReachEnd={handleReachEnd}
                    onReachBeginning={handleReachBeginning}
                >
                    {moreLists?.map((item: any, k: number) => (
                        <SwiperSlide key={k} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                            <Image
                                className="whatsMore-img fullImgs"
                                src={item.img || '/img/search/error.png'}
                                width={960}
                                height={510}
                                alt={t(`preview.${item.title}`)}
                                aria-label={t(`preview.${item.title}`)}
                            />

                            <div className="whatsMore-item">
                                <h2 className="whatsMore-item-title font-family-bold">{t(`preview.${item.title}`)}</h2>
                                <p className="whatsMore-item-desc">
                                    {t(`preview.${item.desc}`)}
                                    <span className="whatsMore-item-note-jp">{item.note}</span>
                                </p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="mm100-preview-footerInfo container">
                <div className="left-info">
                    <h4 className="info-title">{t('preview.info_title')}</h4>
                    <ol className="info-lists">
                        {infoLists?.map((info: any) => (
                            <li className="info-list" key={info.key}>
                                {t(`preview.${info.i18n}`)}
                            </li>
                        ))}
                    </ol>
                </div>
                <div className="right-info">
                    <div className="right-info-arrow">
                        <Image
                            src="/icons/mm100/mm100-preview-arrow.svg"
                            width={84.61}
                            height={161.78}
                            className="fullImgs"
                            alt={t('preview.get_preview')}
                            aria-label={t('preview.get_preview')}
                        />
                    </div>
                    <span aria-label={t('preview.get_preview')} onClick={handleBackToEmail}>
                        <span className="right-info-previewBtn">{t('preview.get_preview')}</span>
                    </span>
                </div>
            </div>

            <Popup visible={popupVisible} tKey="ecoflowpowerkits" onCancel={() => setPopupVisible(false)} />
        </div>
    );
}

export function loadScript(url: string) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script') as any;
        if (script.readyState) {
            script.onreadystatechange = () => {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    // 因为只加载第三方插件，第三方script里有内嵌的jquery，所以存在window.jQuery, 此函数在其他地方不通用
                    resolve(window.jQuery || null);
                }
            };
        } else {
            script.onload = () => {
                resolve(window.jQuery || null);
            };
        }

        script.onerror = () => {
            reject();
        };

        script.src = url;
        document.body.appendChild(script);
    });
}
